import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import './index.css'
import { AuthProvider } from './hooks/useAuth'
import { UserSessionProvider } from './hooks/useUserSession'
import { ToastProvider } from './components/ui/toast'
import { initializeSentry } from './lib/sentry'

initializeSentry()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <AuthProvider>
        <UserSessionProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </UserSessionProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
)
